require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window

// bl_registry/registry/show (guest view)
ns.RegistryGuestApp =
  require('./registry/components/registry-guest-app').default

ns.ReactRailsUJS = require('react_ujs')
